/**
 * US phone inputs are always (XXX) XXX-XXXX — ten digits, no country code.
 */

/** Extract up to 10 digits from display input. */
export const extractPhoneDigits = (value) => (value || '').replace(/\D/g, '').slice(0, 10);

/** Format digits as (XXX) XXX-XXXX for display in inputs. */
export const formatUsPhoneDisplay = (value) => {
  const digits = extractPhoneDigits(value);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

/** (XXX) XXX-XXXX for API payloads (empty → null). */
export const normalizePhoneForApi = (value) => {
  const digits = extractPhoneDigits(value);
  if (digits.length === 0) return null;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};
